export default {
  state: {
    guideItems: {},
    guideDescription: '',
  },
  mutations: {
    createGuideItemEditor(state, guideItem) {
      state.guideItems[guideItem.editorId] = guideItem;
    },
    createGuideDescription(state, guideDescription) {
      state.guideDescription = guideDescription;
    },
    deleteGuideItemEditor(state, editorId) {
      delete state.guideItems[editorId];
    },
    updateGuideItemEditorTitle(state, payload) {
      state.guideItems[payload.editorId].title = payload.title;
    },
    updateGuideItemEditorDescription(state, payload) {
      state.guideItems[payload.editorId].description = payload.description;
    },
    updateGuideItemEditorType(state, payload) {
      state.guideItems[payload.editorId].type = payload.type;
    },
    updateGuideItemEditorItemId(state, payload) {
      state.guideItems[payload.editorId].itemId = payload.itemId;
    },
    updateGuideItemEditorId(state, payload) {
      state.guideItems[payload.editorId].id = payload.id;
    },
    updateGuideEditorDescription(state, description) {
      state.guideDescription = description;
    },
    swapGuideItemEditorRelativeOrders(state, payload) {
      let tempRelativeOrder = state.guideItems[payload.editorIdA].relativeOrder;
      state.guideItems[payload.editorIdA].relativeOrder = state.guideItems[payload.editorIdB].relativeOrder;
      state.guideItems[payload.editorIdB].relativeOrder = tempRelativeOrder;
    },
  },
};
